import React from "react";
import { Icons } from "./sidebarIcons";

export const getMemberSidebarConfig = ({
  access,
  userData,
  schoolData,
  Notification,
  showInvitesOffcanvas,
  setShowInvitesOffcanvas,
  hasPendingInvite,
  hasUnseenInvite,
}) => {
  return [
    {
      label: "Dashboard",
      path: "/dashboard",
      icon: <Icons.Dashboard />,
      show: access?.canViewMemberDashboard ?? true,
    },
    {
      label: "Browse",
      path: "/browse",
      icon: <Icons.Browse />,
      show: access?.canViewBrowse ?? true,
    },
    {
      label: "Collections",
      path: "/collections",
      icon: <Icons.Collections />,
      show: access?.canViewCollections ?? true,
    },
    {
      label: "Strategy Packs",
      path: "/packs",
      icon: <Icons.StrategyPacks />,
      show: access?.canViewStrategyPacks ?? true,
      notificationDot: userData?.role === "School" && Notification?.notifyCount > 0,
    },
    {
      label: "Learners",
      path: "/students",
      icon: <Icons.Learners />,
      show: access?.canViewLearners ?? false,
    },
    {
      label: "Parents",
      path: "/parents",
      icon: <Icons.Parents />,
      show: access?.canViewParents ?? true,
    },
    {
      label: "Worker",
      path: "/workers",
      icon: <Icons.Worker />,
      show: access?.canViewWorkers ?? access?.canViewParents ?? true,
    },
    {
      label: "Classes",
      path: "/classes",
      icon: <Icons.Classes />,
      show: access?.canViewClasses ?? false,
    },
    {
      label: "Teachers",
      path: "/teachers",
      icon: <Icons.Teachers />,
      show: access?.canViewTeachers ?? false,
    },
    {
      label: "Manage Admin",
      path: "/manage-admin",
      icon: <Icons.ManageAdmin />,
      show: access?.canManageAdmin ?? false,
    },
    // {
    //   label: "Group Invites",
    //   isButton: true,
    //   onClick: () => setShowInvitesOffcanvas(true),
    //   isActive: showInvitesOffcanvas,
    //   icon: <Icons.GroupInvites />,
    //   show: access?.canViewGroupInvites ?? false,
    //   notificationDotYellow: hasUnseenInvite,
    // },
    {
      label: "Resource Mapping",
      path: "https://www.peerscroller.com/resources/pshe-association-content-guide",
      isExternal: true,
      icon: <Icons.ResourceMapping />,
      show: access?.canViewResourceMapping ?? true,
    },
    {
      label: "Manage Organisation",
      path: "/school-profile",
      icon: <Icons.ManageOrganisation />,
      show: userData?.role === "School",
      notificationDot: hasPendingInvite,
    }
  ];
};

export const getOrganisationSidebarConfig = ({ access }) => {
  return [
    {
      label: "Dashboard",
      path: "/organisations/dashboard",
      icon: <Icons.Dashboard />,
      show: access?.canViewGroupDashboard ?? true,
    },
    {
      label: "Member Organisations",
      path: "/organisations/member-organisations",
      icon: <Icons.MemberOrganisations />,
      show: access?.canViewMemberOrganisations ?? false,
    },
    {
      label: "Org Group Users",
      path: "/organisations/members",
      icon: <Icons.OrgGroupUsers />,
      show: access?.canViewMemberOrganisations ?? false,
    },
    {
      label: "Member Org Staff",
      path: "/organisations/staff",
      icon: <Icons.Teachers />, // uses school icon
      show: access?.canViewStaff ?? false,
    },
  ];
};

export const getAccountSidebarConfig = ({ access }) => {
  const shouldUseOrgPaths = !access?.hasMemberAccess;

  return [
    {
      label: "Help & Support",
      path: shouldUseOrgPaths ? "/organisations/help-support" : "/help-support",
      activePaths: shouldUseOrgPaths
        ? ["/organisations/help-support", "/organisations/report-issue"]
        : ["/help-support", "/report-issue"],
      icon: <Icons.HelpSupport />,
      show: true,
    },
    {
      label: "Settings",
      path: shouldUseOrgPaths ? "/organisations/settings" : "/settings",
      icon: <Icons.Settings />,
      show: true,
    },
  ];
};
